module.exports = "/_next/static/images/img_1-mobile-bd68155f0a9479d69501214c3593b92d.png";